// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".general-container[data-v-59845ee2]{display:flex}.over-input[data-v-59845ee2]{background:#1a6c99;position:absolute;border:1px solid #1a6c99;border-radius:50%;width:32px;height:32px;margin:0 auto;right:30px;top:50%;transform:translateY(-50%);display:flex}.over-input img[data-v-59845ee2]{padding-top:1px;padding-left:1px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
